var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/FolderWithPlus.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
export const FolderWithPlus = ({
  color = '#353B60',
  ...other
}) => /*#__PURE__*/_jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: /*#__PURE__*/_jsx("path", {
    d: "M20 6H12.8284C12.298 6 11.7893 5.78929 11.4142 5.41421L10.5858 4.58579C10.2107 4.21071 9.70201 4 9.17157 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V8C22 6.89 21.11 6 20 6ZM20 17.5C20 17.7761 19.7761 18 19.5 18H4.5C4.22386 18 4 17.7761 4 17.5V6.5C4 6.22386 4.22386 6 4.5 6H8.34157C8.87201 6 9.38071 6.21071 9.75579 6.58579L10.5842 7.41421C10.9593 7.78929 11.468 8 11.9984 8H19.5C19.7761 8 20 8.22386 20 8.5V17.5ZM12 13.5C12 13.7761 12.2239 14 12.5 14H14V15.5C14 15.7761 14.2239 16 14.5 16H15.5C15.7761 16 16 15.7761 16 15.5V14H17.5C17.7761 14 18 13.7761 18 13.5V12.5C18 12.2239 17.7761 12 17.5 12H16V10.5C16 10.2239 15.7761 10 15.5 10H14.5C14.2239 10 14 10.2239 14 10.5V12H12.5C12.2239 12 12 12.2239 12 12.5V13.5Z",
    fill: color
  })
});